export type LegalDoc = {
  title: string;
  description: string;
  sections: { heading: string; body: string }[];
};

const NOTE =
  "This document is a working draft. Have it reviewed by qualified legal counsel before relying on it.";

export const LEGAL: Record<"privacy" | "terms" | "cancellation", LegalDoc> = {
  privacy: {
    title: "Privacy Policy",
    description: "How NEXORA Web Studio collects, uses and protects your information.",
    sections: [
      { heading: "Information we collect", body: "Information you submit through our forms — such as your name, email, phone number, business details and project notes — and basic analytics about how our site is used." },
      { heading: "How we use it", body: "To respond to inquiries, deliver and support the services you request, send invoices, and improve our website. We do not sell your personal information." },
      { heading: "Sharing", body: "We share information only with service providers that help us operate (for example hosting, email and payment providers), and only as needed to provide our services." },
      { heading: "Your choices", body: "You can ask us to access, correct or delete your information at any time by emailing webstudiosn@gmail.com." },
      { heading: "Contact", body: "Questions about privacy can be sent to webstudiosn@gmail.com." },
      { heading: "Note", body: NOTE },
    ],
  },
  terms: {
    title: "Terms of Service",
    description: "The terms that apply when you work with NEXORA Web Studio.",
    sections: [
      { heading: "Services", body: "NEXORA Web Studio provides website design and development, hosting and maintenance, and related services as agreed in writing with each client." },
      { heading: "Pricing", body: "Website Development is $600 one time. Hosting & Maintenance is $75/month. Work outside the agreed scope is quoted and approved before it begins." },
      { heading: "Client responsibilities", body: "Clients provide accurate business information, content and timely feedback, and confirm they have rights to any materials they supply." },
      { heading: "Approvals", body: "Designs are approved before build, and sites are reviewed on a preview link before launch." },
      { heading: "Hosting", body: "Hosting & Maintenance is month-to-month and may be cancelled according to our Cancellation Policy." },
      { heading: "Note", body: NOTE },
    ],
  },
  cancellation: {
    title: "Cancellation Policy",
    description: "How to cancel Hosting & Maintenance with NEXORA Web Studio.",
    sections: [
      { heading: "No long-term contract", body: "Hosting & Maintenance ($75/month) is billed monthly. There is no long-term commitment and you can cancel anytime." },
      { heading: "How to cancel", body: "Email webstudiosn@gmail.com or call (702) 521-3889 or (702) 802-8436 with your request, or submit it from your client dashboard." },
      { heading: "Website Development", body: "The one-time $600 Website Development fee covers the build of your agreed scope. Questions about work already in progress should be raised directly with the studio." },
      { heading: "After cancellation", body: "We'll confirm your cancellation and discuss next steps for your site, domain and files." },
      { heading: "Note", body: NOTE },
    ],
  },
};
